import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './Reject.scss';
import * as actions from './Reject.actions';
import * as selectors from './Reject.selectors';
import { Helmet } from 'react-helmet';
import Favicon from 'react-favicon';

const Reject = (props) => {
    /* State to props */
    const rejecting = useSelector(selectors.getRejecting);
    const result = useSelector(selectors.getResult);

    /* Dispatch to props */
    const dispatch = useDispatch();
    const rejectOrder = useCallback((token) => dispatch(actions.rejectOrder(token)), [dispatch]);

    /* componentDidMount */
    useEffect(() => {
        rejectOrder(props.match.params.token);
    }, [rejectOrder, props.match.params.token]);

    let loadingRow = null;
    if (parseInt(result) === 1) {
        loadingRow = (
            <div>
                <h2>Order Rejected!</h2>
                <h3>The order was rejected, an email has been sent to notify the user of the order.</h3>
            </div>
        );
    } else if (parseInt(result) === 2) {
        loadingRow = (
            <div>
                <h2>Order already approved</h2>
                <h3>The order was already approved before.</h3>
            </div>
        );
    } else if (parseInt(result) === 3) {
        loadingRow = (
            <div>
                <h2>Order already rejected</h2>
                <h3>The order was already rejected before.</h3>
            </div>
        );
    } else if (rejecting) {
        loadingRow = <div><i className="fas fa-circle-notch fa-spin" /> Rejecting order...</div>
    }

    return (
        <div>
            <Helmet>
                <title>UT Physicians</title>
            </Helmet>
            <Favicon url="https://ac-ut-health.s3.amazonaws.com/favicon.ico" />
            <div className="approve-container">
                <div className="header">UT Physicians</div>
                <div className="content">
                    {loadingRow}
                </div>
                <div className="footer">
                    <div className="powered">
                        Powered by Absolute Color
                        <br />
                        Online Division
                    </div>
                </div>
            </div>
        </div>
    );
};

Reject.propTypes = {

};

export default Reject;
